import MetadataEditor from './MetadataEditor';
export default MetadataEditor;
